export function transformUTGMainData(data){
    let newObj = []
if(data && data.length > 0){
    data.forEach((element, i) => {
        if(newObj.find((ee)=> ee.label === element.label)){
            if(element.sto_color === 'null'){
                newObj = newObj.map((e)=> {
                    if(e.label === element.label){
                        return {...e,
                            ctryC: element.ctry,
                            stoC: element.sto,
                        }
                    }
                    return e
                })
            }
        }else{
            newObj.push({
                label: element.label,
                ctry: element.ctry,
                sto: element.sto,
                ctryC: '',
                stoC: '',
                sto_color: element.sto_color,
            })
        }
    });
}
return newObj
}